import { useQuery } from 'react-query';
import { useSelector } from 'react-redux';
import { selectUserDetails } from '../../reducers/userReducer';
import { fetchUserPreferences, UserPreferences } from './UserPreferencesApi';

const userPreferencesQueryKey = 'me-preferences';

export type UserPreferencesQueryKey = [string, number | null];

// The user id in the query key keeps the cache apart when an admin starts or stops impersonating.
export function useUserPreferencesQueryKey(): UserPreferencesQueryKey {
    const userDetails = useSelector(selectUserDetails);
    const userId = userDetails && userDetails.id != null ? userDetails.id : null;
    return [userPreferencesQueryKey, userId];
}

export function useUserPreferencesQuery(enabled: boolean) {
    const queryKey = useUserPreferencesQueryKey();

    return useQuery<UserPreferences>(queryKey, () => fetchUserPreferences(), {
        enabled,
        staleTime: Infinity,
        refetchOnWindowFocus: false
    });
}
